import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AppLayoutFacadeService} from '../app-layout-facade.service';
import {map, tap} from 'rxjs/operators';
import {ProfileType} from '@model/profile';

@Injectable({
  providedIn: 'root'
})
export class ParentAccessRightGuard  {

  constructor(private _appLayoutFacade: AppLayoutFacadeService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._appLayoutFacade.selectedProfile$.pipe(
      map(profile => profile.type == ProfileType.PARENT),
      tap(accessAllowed => {
        if (!accessAllowed) {
          this._router.navigate(['/']);
        }
      })
    );
  }

}
